module.exports = __webpack_public_path__ + "img/实验室通风系统3.08530a22.jpg";